import React from "react";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Team from "./components/Team";
import Company from "./components/Company";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import SeoJsonLd from "../../components/feature/SeoJsonLd";

export default function Home() {
  try {
    return (
      <div className="min-h-screen">
        <SeoJsonLd />
        <Hero />
        <Services />
        <Team />
        <Company />
        <CTA />
        <Footer />
      </div>
    );
  } catch (error) {
    console.error("Error rendering Home component:", error);
    return <div>Something went wrong.</div>;
  }
}
